import { SOCIAL_LINKS } from 'constants/general';
export const SOCIALS = [
    {
        id: 'discord',
        icon: 'discord-logo',
        url: SOCIAL_LINKS.DISCORD,
    },
    {
        id: 'telegram',
        icon: 'telegram-logo',
        url: SOCIAL_LINKS.TELEGRAM,
    },
    {
        id: 'twitter',
        icon: 'twitter-logo',
        url: SOCIAL_LINKS.TWITTER,
    },
    {
        id: 'github',
        icon: 'github-logo',
        url: SOCIAL_LINKS.GITHUB,
    },
];
